






































































































































































































































































import DragUpload from '@/components/util/DragUpload.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import FloorPicker from '@/components/system/FloorPicker.vue';
import Location2Picker from '@/components/system/Location2Picker.vue';
import ContactPicker from '@/components/system/ContactPicker.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  SystemApi,
  WorkordersApi,
  UsersApi,
  Workorder,
  User as PmoUser,
  ValidationProblemDetails,
  Property,
  PerformoSettings,
  Contact
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {
    DragUpload,
    DetailLayout,
    FloorPicker,
    Location2Picker,
    ContactPicker
  },
  computed: mapGetters({
    currentProperty: 'currentProperty',
    settings: 'settings'
  })
})
export default class Create extends Vue {
  private sys = new SystemApi(this.$store.getters.getApiConfiguration);
  private usersApi = new UsersApi(this.$store.getters.getApiConfiguration);
  private currentProperty!: Property;
  private settings!: PerformoSettings;

  private showContactPicker = false;
  private selectedContact: Contact = {};

  hasPhoto = false;
  currentPerformoUserAndContact: PmoUser = { contact: {} };

  get currentUserName(): string {
    return this.$store.getters.userDisplayName;
  }
  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }
  get allowReqCreate(): boolean {
    if (!this.settings.requireProfileForRequests) return true;
    if (!this.settings.requiredProfileAttributes) return true;
    // Check the contact has a value for every required attribute
    const result = this.settings.requiredProfileAttributes.every((attr) => {
      if (!this.currentPerformoUserAndContact.contact) return false;
      // https://stackoverflow.com/questions/56833469/typescript-error-ts7053-element-implicitly-has-an-any-type/56833507#56833507
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const contact: { [index: string]: any } =
        this.currentPerformoUserAndContact.contact;
      return contact[attr] ? true : false;
    });
    return result;
  }

  private createOrderWatcher = false;
  private order!: Workorder; // = {};
  private validationProblems: ValidationProblemDetails = {};

  data() {
    return {
      order: {
        building: undefined,
        floor: undefined,
        suite: undefined
      } as Workorder
    };
  }

  private async mounted() {
    this.currentPerformoUserAndContact = await this.usersApi.getMyProfile();

    if (
      this.currentPerformoUserAndContact &&
      this.currentPerformoUserAndContact.contact
    ) {
      this.order.building =
        this.currentPerformoUserAndContact.contact.location1;
      this.order.floor = this.currentPerformoUserAndContact.contact.floor;
      this.order.suite = this.currentPerformoUserAndContact.contact.location2;
    }
  }

  private successHandler(order: Workorder) {
    if (order && order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      const el = document.getElementById('error-display');
      if (el) {
        el.scrollIntoView(true);
      }
    }, 100);
  }

  private fileAddedHandler() {
    this.hasPhoto = true;
  }

  @Watch('currentPropertyId', { immediate: true })
  private propertyIdChanged(newPropertyId: string) {
    this.order.propertyId = newPropertyId;
  }

  private async createRequest() {
    // attach propertyId at create time.
    this.order.propertyId = this.currentPropertyId;

    // if a file is attached, we have to use the upload er to do the upload as well as the form submission
    // otherwise we hit the api directly.
    if (this.hasPhoto) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.dragupload as any).processUploadQueue();
    } else {
      const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
      wkoApi
        .createRequest({ workorderCreateCommand: this.order })
        .then(this.successHandler, this.errorHandler);
    }
  }

  private toggleContactPicker() {
    if (this.showContactPicker) {
      this.order.contactId = null;
      this.selectedContact = {};
      this.showContactPicker = false;
    } else {
      this.showContactPicker = true;
    }
  }

  private updateSelectedContact(contact: Contact) {
    if (contact) {
      this.selectedContact = contact;
    } else {
      this.selectedContact = {};
    }
  }
}
